import api from './api';

const taxService = {
  calculate: (items, country = 'US', state = '') =>
    api.post('/tax/calculate', { items, country, state }),
  getRates: (country) => api.get(`/tax/rates/${country}`),
};

export default taxService;
